import {
    ColoursObj,
    Typography,
    VerticalExpander,
} from '@eventr/common-storybook'
import { Box, Chip } from '@mui/material'
import { useState } from 'react'
import { ArrowFlip } from '../../../assets/animated/arrowFlip'

interface RefundPolicyProps {
    refundPolicy: string
}

export const RefundPolicy = ({ refundPolicy }: RefundPolicyProps) => {
    const [open, setOpen] = useState<boolean>(false)
    if (!refundPolicy) return null
    if (refundPolicy === 'NONREFUNDABLE' || refundPolicy === 'Nonrefundable')
        return (
            <Chip
                style={{
                    borderRadius: '4px',
                    backgroundColor: ColoursObj.states.errorLight,
                    color: ColoursObj.shades.shade1,
                    fontSize: '12px',
                }}
                label={refundPolicy}
            />
        )
    if (refundPolicy.startsWith('NONREFUNDABLE -')) {
        return (
            <Box display={'grid'}>
                <Chip
                    style={{
                        borderRadius: '4px',
                        backgroundColor: ColoursObj.states.errorLight,
                        color: ColoursObj.shades.shade1,
                        fontSize: '12px',
                    }}
                    label={'NONREFUNDABLE'}
                    onClick={() => {
                        setOpen(!open)
                    }}
                    icon={
                        <ArrowFlip
                            open={open}
                            colour={ColoursObj.shades.shade1}
                        />
                    }
                />
                <VerticalExpander open={open}>
                    <Box padding={'8px'}>
                        <Typography
                            variant="bodySubtext"
                            lineHeight={'12px'}
                            color={ColoursObj.font.secondary}
                        >
                            {refundPolicy}
                        </Typography>
                    </Box>
                </VerticalExpander>
            </Box>
        )
    }
    if (refundPolicy.startsWith('Free cancellation before')) {
        return (
            <Chip
                style={{
                    borderRadius: '4px',
                    backgroundColor: ColoursObj.states.successLight,
                    color: ColoursObj.shades.shade1,
                    fontSize: '12px',
                }}
                label={refundPolicy}
            />
        )
    }
    return (
        <Box display={'grid'}>
            <Chip
                style={{
                    borderRadius: '4px',
                    backgroundColor: ColoursObj.states.warningLight,
                    color: ColoursObj.shades.shade1,
                    fontSize: '12px',
                }}
                label={'REFUNDABLE'}
                onClick={() => {
                    setOpen(!open)
                }}
                icon={
                    <ArrowFlip open={open} colour={ColoursObj.shades.shade1} />
                }
            />
            <VerticalExpander open={open}>
                <Box padding={'8px'}>
                    <Typography
                        variant="bodySubtext"
                        lineHeight={'12px'}
                        color={ColoursObj.font.secondary}
                    >
                        {refundPolicy}
                    </Typography>
                </Box>
            </VerticalExpander>
        </Box>
    )
}
